/**
 * EventHandler class for managing DOM event listeners
 */
class EventHandler {
  constructor() {
    this.events = [];
  }

  register(el, event, listener) {
    if (!el || !event || !listener) return null;
    this.events.push({ el, event, listener });
    el.addEventListener(event, listener);
    return { el, event, listener };
  }

  unregister({ el, event, listener }) {
    if (!el || !event || !listener) return null;
    this.events = this.events.filter(
      (e) => el !== e.el || event !== e.event || listener !== e.listener
    );
    el.removeEventListener(event, listener);
    return { el, event, listener };
  }

  unregisterAll() {
    this.events.forEach(({ el, event, listener }) => {
      el.removeEventListener(event, listener);
    });
    this.events = [];
  }
}

class MetaDataClass {

    fillValues() {
        this.getCustomerMetaDataJson();
    }

    createMetaData(postData) {

        let url = 'https://create-metadata.spellbindersmarketing.workers.dev/';
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData),
        })
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                let metafield = data.metafield;
                jQuery(`[data-meta-key="${metafield.key}"]`).val(metafield.value);
                jQuery(`[data-meta-key="${metafield.key}"]`).attr('data-action', 'update');
                jQuery(`[data-meta-key="${metafield.key}"]`).attr('data-metafield-id', metafield.id);
            });

    }

    updateCustomerMateData(postData) {
        let url = 'https://update-metadata.spellbindersmarketing.workers.dev/';

        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData),
        })
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                let metafield = data.metafield;
                jQuery(`[data-meta-key="${metafield.key}"]`).val(metafield.value);
                jQuery(`[data-meta-key="${metafield.key}"]`).attr('data-action', 'update');
                jQuery(`[data-meta-key="${metafield.key}"]`).attr('data-metafield-id', metafield.id);
            });

    }

    getCustomerMetaDataJson() {

        let url = 'https://getcustomermetadata.spellbindersmarketing.workers.dev/';
        let customerId = $("#wholesale-information-content").attr("data-customer-id");
        let postData = { "id": customerId };
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData),
        })
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                data.metafields.forEach(metafield => {
                    jQuery(`[data-meta-key="${metafield.key}"]`).val(metafield.value);
                    jQuery(`[data-meta-key="${metafield.key}"]`).attr('data-action', 'update');
                    jQuery(`[data-meta-key="${metafield.key}"]`).attr('data-metafield-id', metafield.id);
                });
                
            })
    }

    renderCustomerMetaData() {
        let html = '<ul>';

        let url = 'https://getcustomermetadata.spellbindersmarketing.workers.dev/';
        let customerId = $("#wholesale-information-content").attr("data-customer-id");
        let postData = { "id": customerId };
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData),
        })
        .then((response) => response.json())
        .then((data) => {
            // console.log(data);

            if (data.errors) {
                this.renderEmptyForm();
            } else if(data.metafields.length == 0){
                this.renderEmptyForm();
            } else {

                let html = `
                    <div class="">
                        <div class="item">
                            <div class="meta-key">3rd Party Shipping Information</div>
                            <div data-meta-key="3rd_party_shipping_info" class="meta-value"></div>
                        </div>
                        <div class="item action">
                            <a href="javascript:void(0)" class="button button-primary btn-wholesale-info-edit">Edit</a>
                        </div>
                    </div>
                `;

                $("#wholesale-information-content .wholesale-display").html(html);

                data.metafields.forEach(metafield => {
                    jQuery(`.wholesale-display [data-meta-key="${metafield.key}"]`).html(metafield.value);
                });                
            }
        });
    }

    renderEmptyForm() {

        let wholesaleHtml = `
            <div class="content-box " >
                <div class="content-box__row">
                <div class="section__content">
                    <div class="fieldset">

                    <div style="display:none" id="success-msg" class="notice notice--success default-background" data-banner="true" role="status" tabindex="-1" aria-atomic="true" aria-live="polite">
                        <div class="notice__content">
                        <p class="notice__text">Data Saved Successfully </p>
                        </div>
                    </div>

                    <div class="field field--required field--full field--show-floating-label">
                        <div class="field__input-wrapper">
                        <label class="field__label field__label--visible" for="wholesale_info">3rd Party Wholesale Information</label>
                        <input placeholder="3rd Party Wholesale Information" class="field__input meta-field" type="text" id="wholesale_info" data-meta-key="3rd_party_shipping_info" data-action="create">
                        </div>
                    </div>

                    <div class="field field--required field--full field--show-floating-label">
                        <a href="javascript:void(0)" class="btn btn-save-metadata button button-primary">
                        <span class="btn__content">Save</span>
                        </a>
                        <a href="javascript:void(0)" class="btn btn-cancel-metadata button button-cancel">
                        <span class="btn__content">Cancel</span>
                        </a>
                    </div>

                    </div>
                </div>
                </div>
            </div>
        `;
        $("#wholesale-information-content .wholesale-form").html(wholesaleHtml);

    }
}
/*
  Custom JS Class for Wholesale Popup on page load.
*/ 
class WholesalePopup {
  constructor() { 
    this.events = new EventHandler();
    this.adminLogin = document.querySelector('.admin-login-modal');
    this.events.register(this.adminLogin, 'click', () => this.openModal());
    this.events.register(document.body, 'click', event => this.closeModal(event));
    
    this.modalWrapper = document.querySelector('.wholesale-onload-modal-wrapper');
    
    this.events.register(this.modalWrapper, 'click', event => this.closeModal(event));
    this.modalContent = this.modalWrapper.querySelector('.wholesale-onload-modal');

    let openPopup = true;    
    if(this.modalWrapper.getAttribute('data-on-load') == "true"){
      if(this.modalWrapper.getAttribute('data-customer-login') == "true"){
        openPopup = false;
      }else{
        openPopup = true;
      }
      let pathToIgnore = ['/account','/pages/apply-now','/challenge'];
      if(pathToIgnore.find(this.checkPath)){
          openPopup = false;
      }
      if(openPopup){
        this.openModal();
      }
    }
    this.events.register(window, 'resize', () => this.positionModal());
  }

  checkPath(path){
    let pathName  =  window.location.pathname;
    pathName = pathName.toLowerCase();
    if( pathName.search(path)  != -1){
      return true;
    }
    return false;
  }

  closeModal(e) {
    /*if (e.target.classList.contains('visible')) {
      this.modalWrapper.classList.remove('visible');
      this.events.register(this.modalWrapper, 'transitionend', () => {
        document.body.classList.remove('scroll-locked');
      });
    }*/
  }

  openModal() {
    document.body.classList.add('scroll-locked');
    this.positionModal();
    this.modalWrapper.classList.add('visible');
    this.events.register(this.modalWrapper, 'transitionend', () => {
      this.modalInput.focus();
    });
  }

  positionModal() {
    const {
      width,
      height
    } = this.modalContent.getBoundingClientRect();
    this.modalContent.style.marginTop = -(height / 2);
    this.modalContent.style.marginLeft = -(width / 2);
  }

  unload() {
    if (this.events) {
      this.events.unregisterAll();
    }
  }

}

new WholesalePopup();

$(document).ready(function () {

    let metaObj = new MetaDataClass();

    $(document).on('click', '.toggle-box', function (e) {
        e.preventDefault();
        $(this).parent().find('.promo').toggleClass('active');
        $(this).parent().find('label').toggleClass('open');
    });


    $(document).on('focusout', '.has-max-qty', function () {
        $('.max-qty-error').remove();
        let currentQty = parseInt($(this).val());
        let allowQty = parseInt($(this).attr('max'));
        if (currentQty > allowQty) {
            $(this).val(allowQty)
            $(this).parent().next().append(`<div class="max-qty-error"> Only maximum ${allowQty} quantity allowed per order</div>`);
        }
    });

    let $t = setInterval(() => {
        if ($('#wholesale-information-content').length) {
            clearInterval($t);
            metaObj.renderCustomerMetaData();
        }
    }, 100);


    $(document).on('click','.btn-cancel-metadata ', function(){
        $('#wholesale-information-content .wholesale-form').hide();
        $('#wholesale-information-content .wholesale-display').show();
        metaObj.renderCustomerMetaData();
    });

    $(document).on('click', '.btn-save-metadata', function(){
        jQuery('.meta-field').each(function(){
            let customerId = $("#wholesale-information-content").attr("data-customer-id");
            if(jQuery(this).attr('data-action') == 'create'){
              let metaData = {
                "metaType":"customers",
                "id":customerId,
                "metafield": {
                  "namespace": "custom",
                  "key": jQuery(this).attr('data-meta-key'),
                  "value": jQuery(this).val(),
                  "type": "single_line_text_field"
                }
              }      
              metaObj.createMetaData(metaData);
            }
      
            if(jQuery(this).attr('data-action') == 'update'){
              let metaData = {
                "customerId":customerId,
                "metafield": {
                    "id":jQuery(this).attr('data-metafield-id'),
                    "value": jQuery(this).val()
                }
              }
              metaObj.updateCustomerMateData(metaData);
            }
        });      
        
        jQuery('#success-msg').show();

        // metaObj.renderCustomerMetaData();
        // $('#wholesale-information-content .wholesale-display').show();

    });

    $(document).on('click','.btn-wholesale-info-edit', function(){
        $('#wholesale-information-content .wholesale-display').hide();
        $('#wholesale-information-content .wholesale-form').show();
        // metaObj.renderCustomerMetaData();
        metaObj.renderEmptyForm();
        metaObj.getCustomerMetaDataJson();
    });

})

